import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function PrivacyPolicy() {
    return (
        <LegalPage title="Privacy Policy" lastUpdated="May 26, 2026">
            <p>
                At{" "}
                <a
                    href="https://www.caribbeanmealprep.net"
                    className="text-forest font-bold underline"
                >
                    Caribbean Meal Prep
                </a>
                , we respect your privacy and are committed to protecting your
                personal information. This Privacy Policy explains how Caribbean
                Meal Prep (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;)
                collects, uses, and protects your information when you visit our
                website, place an order, or interact with our services.
            </p>

            <h2>Information We Collect</h2>
            <p>
                When you use our website or services, we may collect the
                following information:
            </p>
            <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Billing and payment information</li>
                <li>Delivery information</li>
                <li>Order history</li>
                <li>Account preferences</li>
                <li>Device and browser information</li>
                <li>Website usage data</li>
            </ul>
            <p>We collect this information when you:</p>
            <ul>
                <li>Place an order</li>
                <li>Create an account</li>
                <li>Subscribe to updates or promotions</li>
                <li>Contact customer support</li>
                <li>Use or browse our website</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We may use your information to:</p>
            <ul>
                <li>Process and fulfill orders</li>
                <li>Send order confirmations and updates</li>
                <li>Improve customer experience</li>
                <li>Provide customer support</li>
                <li>Send promotions, discounts, or marketing emails</li>
                <li>Improve website performance and services</li>
                <li>Prevent fraud and protect our business</li>
            </ul>

            <h2>Payment Information</h2>
            <p>
                Payments made through our website are processed securely by
                trusted third-party payment providers. We do not store your
                full payment card information on our servers.
            </p>

            <h2>Marketing Communications</h2>
            <p>
                By providing your contact information, you may receive
                promotional emails or text messages from Caribbean Meal Prep.
                You can unsubscribe at any time by clicking the unsubscribe link
                in emails or contacting us directly.
            </p>

            <h2>Cookies &amp; Tracking Technologies</h2>
            <p>Our website may use cookies and similar technologies to:</p>
            <ul>
                <li>Improve website functionality</li>
                <li>Remember preferences</li>
                <li>Analyze website traffic</li>
                <li>Personalize your experience</li>
            </ul>
            <p>You may disable cookies through your browser settings.</p>

            <h2>Sharing of Information</h2>
            <p>
                We do not sell your personal information. We may share
                information with trusted third-party providers that help us
                operate our business, including:
            </p>
            <ul>
                <li>Payment processors</li>
                <li>Delivery partners</li>
                <li>Email and marketing platforms</li>
                <li>Website hosting providers</li>
                <li>Analytics services</li>
            </ul>
            <p>
                These providers are only given access to the information
                necessary to perform their services.
            </p>

            <h2>Data Security</h2>
            <p>
                We take reasonable precautions to protect your personal
                information. However, no online transmission or storage system
                is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2>Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
                <li>Access your personal information</li>
                <li>Request corrections</li>
                <li>Request deletion of your information</li>
                <li>Opt out of marketing communications</li>
            </ul>
            <p>
                To make a request, please contact us through our website:{" "}
                <a
                    href="https://www.caribbeanmealprep.net"
                    className="text-forest font-bold underline"
                >
                    www.caribbeanmealprep.net
                </a>
            </p>

            <h2>Children&rsquo;s Privacy</h2>
            <p>
                Our services are not intended for children under the age of 13,
                and we do not knowingly collect personal information from
                children.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Any changes
                will be posted on this page with an updated effective date.
            </p>

            <h2>Contact Us</h2>
            <p>
                If you have any questions regarding this Privacy Policy, please
                contact us:
            </p>
            <ul>
                <li>
                    Website:{" "}
                    <a
                        href="https://www.caribbeanmealprep.net"
                        className="text-forest font-bold underline"
                    >
                        www.caribbeanmealprep.net
                    </a>
                </li>
                <li>
                    Email:{" "}
                    <a
                        href="mailto:caribbeanmealp@gmail.com"
                        className="text-forest font-bold underline"
                    >
                        caribbeanmealp@gmail.com
                    </a>
                </li>
            </ul>
        </LegalPage>
    );
}
